export default __webpack_public_path__ + "static/media/udaipur3.23fd7af8.jpg";